import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Text } from '@/components/typography';
import { ContentContainer } from '@/components/layout';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadButton, Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { OldDocumentsToggle } from '@/sections/documents/OldDocumentsToggle';
import { FILES } from '@/constants/files';
import { useRouter } from 'next/router';
export function TryItForFree() {
  const $ = _c(60);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["postponeDueDate", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] !== t) {
    t1 = t("tryItForFree.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="w-full"><Image src="/images/sections/postponeDueDate/cs/heart-brain-free.png" alt={t1} width={600} height={552} className="mx-auto max-w-[90%] md:max-w-full" /></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("tryItForFree.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <SectionHeadline className="mb-5 px-0 lg:text-left" anchorKey="tryItForFree.title">{t3}</SectionHeadline>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("tryItForFree.text");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Text variant="p2" className="text-center text-gray-800 lg:text-left">{t5}</Text>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div>{t4}{t6}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("tryItForFree.less");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("tryItForFree.more");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("tryItForFree.items.1");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <li>{t10}</li>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("tryItForFree.items.2");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <li>{t12}</li>;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t("tryItForFree.items.3");
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14) {
    t15 = <li>{t14}</li>;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t11 || $[33] !== t13 || $[34] !== t15) {
    t16 = <ul className="mt-4 mb-8 list-disc space-y-3 pl-5 marker:text-blue-500">{t11}{t13}{t15}</ul>;
    $[32] = t11;
    $[33] = t13;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16 || $[37] !== t8 || $[38] !== t9) {
    t17 = <div><OldDocumentsToggle openedTitle={t8} closedTitle={t9}>{t16}</OldDocumentsToggle></div>;
    $[36] = t16;
    $[37] = t8;
    $[38] = t9;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== locale) {
    t18 = FILES(locale);
    $[40] = locale;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  const t19 = t18.conditionsPromoTryItForFree;
  let t20;
  if ($[42] !== t) {
    t20 = t("tryItForFree.file");
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t18.conditionsPromoTryItForFree || $[45] !== t20) {
    t21 = <DownloadButton testId="postponeDueDateConditions" analyticsParam="postponeDueDateConditions" to={t19} className="w-86! max-w-full">{t20}</DownloadButton>;
    $[44] = t18.conditionsPromoTryItForFree;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = LINKS();
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  const t23 = t22.registration;
  let t24;
  if ($[48] !== t) {
    t24 = t("tryItForFree.cta");
    $[48] = t;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t24) {
    t25 = <Button to={t23} testId="tryItForFreeRegistration" analyticsParam="tryItForFreeRegistration" variant="primary" className="w-86! max-w-full">{t24}</Button>;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t17 || $[53] !== t21 || $[54] !== t25 || $[55] !== t7) {
    t26 = <div className="flex w-full flex-col items-center gap-6 lg:items-start lg:gap-8">{t7}{t17}{t21}{t25}</div>;
    $[52] = t17;
    $[53] = t21;
    $[54] = t25;
    $[55] = t7;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t2 || $[58] !== t26) {
    t27 = <ContentContainer><div className="flex flex-col items-center gap-12 lg:flex-row lg:gap-32">{t2}{t26}</div></ContentContainer>;
    $[57] = t2;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  return t27;
}